import { ItemListContextMenu } from 'common/define'
import CListItemContextMenu from 'components/CListItemContextMenu'
import { useContextListOpenFile } from 'context/listopenfile.context'
import { cachedFiles } from 'helper/dashboard.helper';
import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { extractFileRequest, getFileStatusRequest } from '../../redux/docai.slice';
import { useSelectorRoot } from 'redux/store';
import { RootState } from 'redux/rootReducers';

const arrAction: ItemListContextMenu[] = [
    { key: 'clear-cache', content: 'Clear cache' },
    { key: 'clear-all-selected', content: 'Clear selected files' },
    { key: 'add-folder', content: 'Add folder' },
    { key: 'add-folder-root', content: 'Add folder in root' },
    { key: 'OPEN_FILE_LOCATION', content: 'View' },
    { key: 'analytic', content: 'Analytic' },
    { key: 'view-analytic', content: 'View Analytic' },
]

type ContextMenuItemProps = Props & {
    handleCloseContext: () => void
}
export default function ContextMenuItem({ handleCloseContext }: ContextMenuItemProps): JSX.Element {
    const { callActions, dispatchContext, state: { arrSelected, dataContext } } = useContextListOpenFile();

    const item = dataContext.itemSelected;
    const isPdf = item?.filename?.toLowerCase().endsWith('.pdf') ?? false;
    const [isCached, setIsCached] = useState(false)
    const dispatch = useDispatch();
    const statusAnalyticFile = useSelectorRoot((state: RootState) => state.docai.fileStatus);
    const [arrDisable, setArrDisable] = useState(['']);

    useEffect(() => {
        const check = async () => {
            if (!item || dataContext.from !== 'file') return
            const res = await cachedFiles([item], '', '')
            const found = res.find(f => f.baseFileId === item.baseFileId)
            setIsCached(!!found)
        }
        check()
    }, [item, dataContext.from])


    useEffect(() => {
        dispatch(getFileStatusRequest(item?.baseFileId || '')); 
    }, [])

    useEffect(() => {
        const arr = [''];
        if (arrSelected.length === 0) {
            arr.push('clear-all-selected')
        }
        if (dataContext.from === 'folder') {
            arr.push('clear-cache')
        }
        if (dataContext.from === 'file') {
            arr.push('add-folder')
        }
        if (!isPdf) {
            arr.push('log');
            arr.push('view-analytic')
            arr.push('analytic');

        }
        if (isPdf) {
            if (!isCached || statusAnalyticFile?.status !== 'success') {
                arr.push('view-analytic');
                if (statusAnalyticFile?.status === 'processing') {
                    arr.push('analytic');
                }
            } else {
                arr.push('analytic')
            }
        }
        setArrDisable(arr)

    }, [statusAnalyticFile])
    const handleAction = useCallback((item: ItemListContextMenu) => {
        handleCloseContext();
        const mapActionKey: Record<string, () => void> = {
            'clear-cache': () => callActions({ type: 'clear-cache', val: 'single' }),
            'clear-all-selected': () => callActions({ type: 'clear-cache', val: 'multiple' }),
            'add-folder': () => dispatchContext({ type: 'VISIBLE_DIALOG', payload: { visible: true, data: 'normal' } }),
            'add-folder-root': () => dispatchContext({ type: 'VISIBLE_DIALOG', payload: { visible: true, data: 'root' } }),
            'OPEN_FILE_LOCATION': () => dispatchContext({ type: "OPEN_FILE_LOCATION", payload: dataContext.itemSelected }),
            'analytic': () => {
                if (!isCached && dataContext.itemSelected && dataContext.itemSelected.baseFileId && dataContext.itemSelected.filename) {
                    dispatch(extractFileRequest({ guid_file: dataContext.itemSelected.baseFileId, path_file: dataContext.itemSelected.originalFilePath.replace("./", "") + '/' + dataContext.itemSelected.filename }));
                    
                } else {
                    dispatchContext({ type: "analytic", payload: dataContext.itemSelected })
                }
            },
            'view-analytic': () => dispatchContext({ type: "view-analytic", payload: dataContext.itemSelected }),
        }
        mapActionKey[item.key]()
    }, [callActions, dispatchContext, handleCloseContext])

    return (
        <CListItemContextMenu data={arrAction} onItemClick={handleAction} arrDisable={arrDisable} />
    )
}
